export const LOAD_DATA_PRESENT =
  'containers/MyPage/PresentGift/LOAD_DATA_PRESENT';
export const LOAD_DATA_SUCCESS =
  'containers/MyPage/PresentGift/LOAD_DATA_SUCCSESS';
export const LOAD_DATA_ERROR = 'containers/MyPage/PresentGift/LOAD_DATA_ERROR';
export const DOWNLOAD_PRESENT_GIFT =
  'containers/MyPage/PresentGift/DOWNLOAD_PRESENT_GIFT';
